import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import snackbarReducer  from "./modules/sc-utilities/snackbar/store/snackbarReducer";

// Compose Enhancers
const composeEnhancers = (process.env.NODE_ENV === "development" ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

// Root Reducer
const rootReducer = combineReducers({
    snackbarState: snackbarReducer
});

// Create store
const snackbarStore = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export default snackbarStore;